<x-page-panel
  [heading]="heading"
  [headingAlignment]="alignment"
  [subHeading]="subHeading"
  class="px-4 px-lg-0"
>
  <div class="d-flex flex-column" [class]="'align-items-' + bodyAlignment">
    <div class="actions" [class]="'justify-content-' + bodyAlignment">
      <ng-content select="[xAction]"></ng-content>
    </div>
  </div>
</x-page-panel>
